<template>
  <SACModal
    modalClass="confirm-exit-popup"
    cardClass="exit-card-container"
    :show="show"
    :close="close"
  >
    <template #content>
      <div class="ac-card-content">
        <div class="ac-body-container">
          <img
            src="@shared/assets/img/general/i-red-diamond.svg"
            class="ac-info-logo"
            alt="Information"
          >
          <div class="ac-header">
            Save Promo as draft?
          </div>
          <div class="ac-body">
            All progress made will be saved as a <b>Draft</b>; it can be found in the <b>Inactive</b> tab on the Offers page.
          </div>
          <div class="flex-row align-center">
            <button
              type="button"
              class="ac-button"
              @click="close"
            >
              Continue editing
            </button>
            <button
              type="button"
              class="ac-button"
              @click="addPromo"
            >
              Save as Draft
            </button>
          </div>
        </div>
      </div>
    </template>
  </SACModal>
</template>

<script>
import SACModal from '@shared/components/sac/SACModal.vue';

export default {
  name: 'MemberWarningPopup',
  components: {
    SACModal,
  },
  props: {
    show: Boolean,
    close: Function,
    addPromo: Function,
  },
};
</script>

<style lang="scss">

.confirm-exit-popup {
  position: relative;

  .ac-card-content {
    display: flex;
    flex-direction: column;
    height: 100%;
    animation: fadeIn 0.5s ease;
    position: relative;

    .ac-body-container {
      width: 500px;
      flex: 1;
      padding: 31px 24px 26px 24px;
      display: flex;
      flex-direction: column;
      align-items: center;

      .ac-info-logo {
        width: 25px;
        object-fit: contain;
        margin-bottom: 4px;
      }

      .ac-header {
        font-size: 1.5em;
        color: $NAVY100;
        font-weight: 500;
        margin-bottom: 32px;
        text-align: center;
        line-height: 1.2;
        width: 70%;
      }

      .ac-body {
        font-size: 1.25em;
        color: $N90;
        text-align: center;

        span {
          text-decoration: underline;
        }
      }

      .ac-button {
        padding: 2px 9px;
        font-size: 0.75em;
        font-weight: 500;
        color: $N90;
        background-color: #CAD7FF;
        border-radius: 3px;
        margin-top: 36px;

        &:first-child {
          margin-right: 10px;
        }

        &.red {
          background-color: $PUNCH !important;
          color: $WHITE !important;
        }
      }
    }
  }
}
</style>
